import { create, type StateCreator } from "zustand";
import { devtools } from "zustand/middleware";
import {
  createCounterSlice,
  counterInitialState
} from "./slices/counterSlice";
import { createUiSlice, uiInitialState } from "./slices/uiSlice";
import {
  createRegulationsListSlice,
  regulationsListInitialState,
} from "./slices/regulationsListSlice";
import type { AppStoreState } from "./types";

export const buildInitialAppState = (): Partial<AppStoreState> => ({
  ...counterInitialState(),
  ...uiInitialState(),
  ...regulationsListInitialState(),
});

const storeCreator: StateCreator<
  AppStoreState,
  [["zustand/devtools", never]],
  [],
  AppStoreState
> = (set, get, api) => ({
  ...createCounterSlice(set, get, api),
  ...createUiSlice(set, get, api),
  ...createRegulationsListSlice(set, get, api),
});

export const useAppStore = create<AppStoreState>()(
  devtools(storeCreator, { name: "app-store" })
);

export const resetAppStoreState = () =>
  useAppStore.setState(buildInitialAppState(), false);
